import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  CardBody,
  Col,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Button,
  Alert,
  Label,
  Input,
  Badge,
} from 'reactstrap';

import Select from 'react-select';

import metaMask from '../../assets/images/nft/newrecord.png';
//import { getMailDetails, deleteMail } from "../../slices/thunks";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import axios from 'axios';
import { api } from '../../config';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const ProcurementView = () => {
  const token = getAuthToken();
  const [isTypeTab, setIsTypeTab] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [data, setData] = useState({ items: [] });
  const [isLoading, setIsLoading] = useState(false);

  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [procTypeFilter, setProcTypeFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [sortField, setSortField] = useState('procurementnumber');
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchText]);

  // Handle search input
  const handleSearch = e => {
    setSearchText(e.target.value);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // Handle sorting
  const handleSort = (column, direction) => {
    // Map column id to the actual field name used by the API
    const fieldMapping = {
      procurementnumber: 'procurementnumber',
      titleprocurement: 'titleprocurement',
      procurementtype: 'procurementtype',
      description: 'description',
      isprocurementcompleted: 'isprocurementcompleted',
    };

    const sortFieldName =
      fieldMapping[column.id] || column.id || 'procurementnumber';
    setSortField(sortFieldName);
    setSortDirection(direction);
  };

  // Get current sort column ID for DataTable
  const getCurrentSortColumnId = () => {
    // Map API field names back to column IDs
    const fieldToColumnMapping = {
      procurementnumber: 'procurementnumber',
      titleprocurement: 'titleprocurement',
      procurementtype: 'procurementtype',
      description: 'description',
      isprocurementcompleted: 'isprocurementcompleted',
    };
    return fieldToColumnMapping[sortField] || 'procurementnumber';
  };

  // Clear all filters
  const clearFilters = () => {
    setSearchText('');
    setStatusFilter('all');
    setProcTypeFilter('all');
    setCurrentPage(1);
  };

  // Handle per rows change
  const handlePerRowsChange = newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  };

  const [setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    titleProcurement: '',
    procurementType: '',
    description: '',
  });

  // Authentication validation
  useEffect(() => {
    if (!token) {
      toast.error('Authentication token not found. Please login again.');
      return;
    }
    if (!isAuthenticated()) {
      toast.error('Please login to access this page.');
      return;
    }
  }, [token]);

  useEffect(() => {
    fetchData(
      currentPage,
      rowsPerPage,
      token,
      debouncedSearchText,
      sortField,
      sortDirection
    );
  }, [
    currentPage,
    rowsPerPage,
    token,
    debouncedSearchText,
    sortField,
    sortDirection,
  ]);

  const procurementtype = [
    {
      options: [
        { label: 'Select Procurement Type', value: '' },
        { label: 'Pelelangan Khusus', value: 'PelelanganKhusus' },
        { label: 'Pemilihan Langsung', value: 'PemilihanLangsung' },
        { label: 'Tunjuk Langsung', value: 'TunjukLangsung' },
      ],
    },
  ];

  const columns = [
    {
      id: 'procurementnumber',
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          ID Proc{' '}
        </span>
      ),
      selector: row => row?.procurementNumber || '',
      sortable: true,
      width: '120px',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row?.procurementNumber || ''}</h6>
          </>
        );
      },
    },

    {
      id: 'titleprocurement',
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Title{' '}
        </span>
      ),
      selector: row => row?.titleProcurement || '',
      sortable: true,
      wrap: true,
      cell: row => {
        return (
          <>
            <h6
              className={'mb-0 text-truncate'}
              title={row?.titleProcurement || ''}
            >
              {row?.titleProcurement || ''}
            </h6>
          </>
        );
      },
    },

    {
      id: 'procurementtype',
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Proc Type{' '}
        </span>
      ),
      selector: row => row?.procurementType || '',
      sortable: true,
      width: '150px',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>
              {procurementTypeMap[row?.procurementType] || '-'}
            </h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Product Type
        </span>
      ),
      selector: row => row?.productType?.product?.name || '',
      sortable: false,
      left: true,
      wrap: true,
      cell: row => {
        return (
          <>
            <div>
              <span className='fw-medium text-truncate d-block'>
                {row?.productType?.product?.name || null}
              </span>{' '}
              <p className='text-muted mb-0 text-truncate small'>
                {row?.productType?.description || null}
              </p>
            </div>
          </>
        );
      },
    },

    {
      id: 'description',
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Description
        </span>
      ),
      selector: row => row?.description || '',
      sortable: true,
      left: true,
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0 text-truncate'} title={row?.description || ''}>
              {row?.description || ''}
            </h6>
          </>
        );
      },
    },

    {
      id: 'isprocurementcompleted',
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Status
        </span>
      ),
      selector: row => row?.isProcurementCompleted || false,
      sortable: true,
      width: '100px',
      className: 'text-end',
      cell: row => {
        return (
          <>
            <div
              className={`badge fs-12 ${
                row?.isProcurementCompleted ? 'bg-success' : 'bg-info'
              }`}
            >
              {row?.isProcurementCompleted ? 'Submitted' : 'Draft'}{' '}
            </div>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '100px',
      sortable: false,
      className: 'text-end',
      headerClassName: 'text-center',
      cell: row => (
        <UncontrolledDropdown>
          <DropdownToggle
            className='btn btn-soft-secondary btn-sm dropdown'
            tag='button'
          >
            {/* <i className='ri-more-fill align-middle'></i> */}
            <i className='ri-more-2-fill align-bottom '></i>
          </DropdownToggle>
          <DropdownMenu className='dropdown-menu-end'>
            <DropdownItem
              tag={Link}
              to={`../apps-procurement/upd/${row?.id || ''}`}
            >
              <i className='ri-edit-line align-bottom me-2 text-info'></i>
              Edit
            </DropdownItem>
            <DropdownItem onClick={() => handleDeleteModal(row?.id)}>
              <i className='ri-delete-bin-line align-bottom me-2 text-danger'></i>
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ];

  const procurementTypeMap = {
    '': '-',
    PelelanganKhusus: 'Pelelangan Khusus',
    PemilihanLangsung: 'Pemilihan Langsung',
    TunjukLangsung: 'Tunjuk Langsung',
  };

  const handleDeleteModal = id => {
    setInvoice({ _id: id });
    setDeleteModal(true);
  };

  const fetchData = async (
    currentPage,
    rowsPerPage,
    token,
    search = '',
    sort = '',
    direction = 'asc'
  ) => {
    // Validate token before making API call
    if (!token || !isAuthenticated()) {
      toast.error('Authentication required. Please login again.');
      return;
    }
    setIsLoading(true);
    let url = `${api.API_URL}/procurement?PageNumber=${currentPage}&PageSize=${rowsPerPage}`;
    // Add search parameters
    if (search && search.trim()) {
      url += `&Search=${encodeURIComponent(search.trim())}`;
    }

    // Add sorting parameters
    if (sort && sort !== '') {
      url += `&SortBy=${sort}`;
      const isDescending = direction === 'desc' ? 'true' : 'false';
      url += `&IsDescending=${isDescending}`;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      setData({
        items: result.data.items || [],
      });
      setTotalRows(result.data.totalItems || 0);
    } catch (error) {
      toast.error('Failed to load procurement data');
    } finally {
      setIsLoading(false);
    }
  };

  const MobileCard = ({ item }) => (
    <div className='card mb-2 d-md-none'>
      <div className='card-body p-3'>
        <div className='d-flex justify-content-between align-items-start mb-2'>
          <h6 className='card-title mb-0 text-truncate flex-grow-1 me-2'>
            {item?.titleProcurement || ''}
          </h6>
          <Badge
            color={item?.isProcurementCompleted ? 'success' : 'info'}
            className='flex-shrink-0'
          >
            {item?.isProcurementCompleted ? 'Submitted' : 'Draft'}
          </Badge>
        </div>

        <div className='mb-2'>
          <small className='text-muted d-block'>
            ID: {item?.procurementNumber || ''}
          </small>
          <small className='text-muted d-block'>
            Type: {procurementTypeMap[item?.procurementType] || '-'}
          </small>
          {item?.productType?.product?.name && (
            <small className='text-muted d-block'>
              Product: {item.productType.product.name}
            </small>
          )}
        </div>

        {item?.description && (
          <p className='card-text text-muted small mb-2 text-truncate'>
            {item.description}
          </p>
        )}

        <div className='d-flex gap-1'>
          <Link
            to={`../apps-procurement/upd/${item?.id || ''}`}
            className='btn btn-sm btn-outline-primary flex-fill'
          >
            <i className='ri-edit-line me-1'></i>Edit
          </Link>
          <Button
            color='outline-danger'
            size='sm'
            className='flex-fill'
            onClick={() => handleDeleteModal(item?.id)}
          >
            <i className='ri-delete-bin-line me-1'></i>Delete
          </Button>
        </div>
      </div>
    </div>
  );

  function toggleTab(tab) {
    if (isTypeTab !== tab) {
      setIsTypeTab(tab);
      console.log(isTypeTab);
    }
  }

  const readAll = () => {
    if (document.querySelectorAll('.message-list li.unread').length === 0) {
      document.getElementById('unreadConversations').style.display = 'block';
      setTimeout(function () {
        document.getElementById('unreadConversations').style.display = 'none';
      }, 1000);
    }

    document
      .querySelectorAll('.message-list li.unread')
      .forEach(function (element) {
        if (element.classList.contains('unread')) {
          element.classList.remove('unread');
        }
      });
  };

  const togglemodal = () => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
      description: '',
    });

    setModal(!modal);
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);

  ///-------------------------------

  const navigate = useNavigate();

  // Original state management

  // Debounce search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchText]);

  // Handle status filter change
  const handleStatusFilter = e => {
    setStatusFilter(e.target.value);
  };

  // Handle procurement type filter change
  const handleProcTypeFilter = e => {
    setProcTypeFilter(e.target.value);
  };

  useEffect(() => {
    if (!token) {
      toast.error('Authentication token not found. Please login again.');
      return;
    }
    if (!isAuthenticated()) {
      toast.error('Please login to access this page.');
      return;
    }
  }, [token]);

  document.title = 'List Planning & Procurement';

  const handleprocurementTypeChange = selectedOption => {
    setFormData({ ...formData, procurementType: selectedOption.value });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateFields = () => {
    let tempErrors = {};
    if (!formData.titleProcurement) {
      tempErrors.titleProcurement = 'Please Enter Title';
    }
    if (!formData.procurementType) {
      tempErrors.procurementType = 'Please Select ';
    }

    if (!formData.description) {
      tempErrors.description = 'Please Enter Description';
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const closeModal = () => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
    });
    setErrors({});
    setModal(!modal);
  };

  const handleSubmit = async e => {
    if (validateFields()) {
      e.preventDefault();
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${api.API_URL}/procurement`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.id) {
          toast.success('Data Has Been Saved');
          navigate(`/apps-procurement/upd/${response.id}`);
        } else {
          toast.error('Failed to save data. Check server response.');
        }
      } catch (error) {
        toast.error(`Failed to save data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData(
      currentPage,
      rowsPerPage,
      token,
      debouncedSearchText,
      sortField,
      sortDirection
    );
  }, [
    currentPage,
    rowsPerPage,
    token,
    debouncedSearchText,
    sortField,
    sortDirection,
  ]);

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />

      <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4 pb-0'>
            <div className='border-bottom border-bottom-dashed'>
              <Row className='mt-n2 mb-3 mb-sm-0'>
                <Col className='col-sm-auto order-1 d-block d-lg-none'>
                  <button
                    type='button'
                    className='btn btn-soft-success btn-icon btn-sm fs-16 email-menu-btn'
                  >
                    <i className='ri-menu-2-fill align-bottom'></i>
                  </button>
                </Col>
                <div className='col-sm order-3 order-sm-2'>
                  <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                    <div id='email-topbar-actions' style={{ display: 'none' }}>
                      <div className='hstack gap-sm-1 align-items-center flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                          id='Tooltip1'
                        >
                          <i className='ri-inbox-archive-fill align-bottom'></i>
                        </button>
                        <button
                          type='button'
                          className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                          id='Tooltip2'
                        >
                          <i className='ri-error-warning-fill align-bottom'></i>
                        </button>
                        <button
                          type='button'
                          className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                          id='Tooltip3'
                          onClick={() => {
                            setDeleteModal(true);
                          }}
                        >
                          <i className='ri-delete-bin-5-fill align-bottom'></i>
                        </button>
                      </div>
                    </div>

                    {/* <div className='vr align-self-center mx-2'></div> */}

                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag='button'
                        className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                      >
                        <i className='ri-more-2-fill align-bottom'></i>
                      </DropdownToggle>
                      <DropdownMenu className='dropdown-menu-end'>
                        <DropdownItem onClick={() => readAll()}>
                          Mark all as Read
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    <Alert
                      color='warning'
                      style={{ display: 'none' }}
                      className='unreadConversations-alert px-4 fade'
                      id='unreadConversations'
                    >
                      No Unread Conversations
                    </Alert>

                    <UncontrolledTooltip placement='top' target='Tooltip1'>
                      {' '}
                      Archive{' '}
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement='top' target='Tooltip2'>
                      {' '}
                      Report Spam{' '}
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement='top' target='Tooltip3'>
                      {' '}
                      Trash{' '}
                    </UncontrolledTooltip>
                  </div>
                </div>
                <div className='col-auto order-2 order-sm-3'>
                  <div className='d-flex gap-sm-1 email-topbar-link'>
                    <button
                      type='button'
                      className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                    >
                      <i className='ri-refresh-line align-bottom'></i>
                    </button>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag='button'
                        className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                      >
                        <i className='bx bx-list-ol align-bottom'></i>
                      </DropdownToggle>
                      <DropdownMenu className='dropdown-menu-end'>
                        <DropdownItem>Export to Excel</DropdownItem>
                        <DropdownItem>Export to CSV</DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </Row>

              <Row className='row align-items-end mt-3 mb-2'>
                <Col xs={12}>
                  <CardHeader className='border-0'>
                    <div className='d-flex align-items-center flex-wrap'>
                      <h5 className='card-title mb-0 flex-grow-1 text-uppercase'>
                        Planning & Procurement
                      </h5>
                      <div className='flex-shrink-0'>
                        <div className='d-flex gap-2 flex-wrap'>
                          <button
                            type='button'
                            className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                            onClick={togglemodal}
                          >
                            <i className='ri-truck-line label-icon align-middle fs-16 ms-2'></i>{' '}
                            <span className='d-none d-sm-inline'>
                              Create New Procurement
                            </span>
                            <span className='d-sm-none'>New</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                </Col>
              </Row>
            </div>

            <div className='message-list-content mx-n4 px-4 message-list-scroll'>
              <Row>
                <Col xs={12}>
                  <CardBody className='pt-0'>
                    {/* Filter Section */}
                    <Row className='mb-3'>
                      <Col xs={12}>
                        <Row className='g-3'>
                          {/* Search Input */}
                          <Col xs={12} md={6} lg={4}>
                            <Label className='form-label'>Search</Label>
                            <Input
                              type='text'
                              placeholder='Search by title or procurement no...'
                              value={searchText}
                              onChange={handleSearch}
                              className='form-control'
                            />
                          </Col>

                          {/* Clear Filters Button */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className='d-flex align-items-end'
                          >
                            <Button
                              color='secondary'
                              outline
                              onClick={clearFilters}
                              className='w-100'
                            >
                              <i className='ri-refresh-line me-1'></i>
                              <span className='d-none d-sm-inline'>
                                Clear Filters
                              </span>
                              <span className='d-sm-none'>Clear</span>
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {/* Results Info */}
                    <Row className='mb-2'>
                      <Col xs={12}>
                        <div className='d-flex justify-content-between align-items-center flex-wrap'>
                          <small className='text-muted'>
                            Showing {data.items?.length || 0} of {totalRows}{' '}
                            entries
                            {(searchText || statusFilter || procTypeFilter) &&
                              ' (filtered)'}
                          </small>
                          {searchText && (
                            <div className='d-flex align-items-center'>
                              <span className='badge bg-primary me-2'>
                                <i className='ri-search-line me-1'></i>
                                Search Active
                              </span>
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>

                    {/* Mobile Card View */}
                    <div className='d-md-none'>
                      {isLoading ? (
                        <div className='table-loading'>
                          <div
                            className='spinner-border text-primary'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                          <p className='mt-2'>Loading procurement data...</p>
                        </div>
                      ) : data.items?.length > 0 ? (
                        data.items.map(item => (
                          <MobileCard key={item.id} item={item} />
                        ))
                      ) : (
                        <div className='table-empty'>
                          <i
                            className='ri-inbox-line'
                            style={{ fontSize: '3rem', opacity: 0.5 }}
                          ></i>
                          <p>No procurement data found</p>
                          {(searchText || statusFilter || procTypeFilter) && (
                            <small>Try adjusting your filters</small>
                          )}
                        </div>
                      )}

                      {/* Mobile Pagination Controls */}
                      <div className='d-flex flex-column align-items-center mt-3 px-2 py-2 border-top'>
                        <div className='d-flex align-items-center mb-2'>
                          <span className='text-muted me-2 small'>
                            Rows per page:
                          </span>
                          <select
                            className='form-select form-select-sm'
                            style={{ width: 'auto' }}
                            value={rowsPerPage}
                            onChange={e =>
                              handlePerRowsChange(parseInt(e.target.value))
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>

                        <div className='d-flex flex-column align-items-center'>
                          <span className='text-muted mb-2 small'>
                            {totalRows > 0 ? (
                              <>
                                {(currentPage - 1) * rowsPerPage + 1}-
                                {Math.min(currentPage * rowsPerPage, totalRows)}{' '}
                                of {totalRows}
                              </>
                            ) : (
                              '0 of 0'
                            )}
                          </span>

                          <div className='btn-group' role='group'>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={currentPage === 1 || isLoading}
                              onClick={() => handlePageChange(1)}
                            >
                              <i className='ri-skip-back-line'></i>
                            </button>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={currentPage === 1 || isLoading}
                              onClick={() => handlePageChange(currentPage - 1)}
                            >
                              <i className='ri-arrow-left-s-line'></i>
                            </button>
                            <span className='btn btn-outline-secondary btn-sm disabled'>
                              {currentPage}
                            </span>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={
                                currentPage >=
                                  Math.ceil(totalRows / rowsPerPage) ||
                                isLoading
                              }
                              onClick={() => handlePageChange(currentPage + 1)}
                            >
                              <i className='ri-arrow-right-s-line'></i>
                            </button>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={
                                currentPage >=
                                  Math.ceil(totalRows / rowsPerPage) ||
                                isLoading
                              }
                              onClick={() =>
                                handlePageChange(
                                  Math.ceil(totalRows / rowsPerPage)
                                )
                              }
                            >
                              <i className='ri-skip-forward-line'></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Desktop Table View */}
                    <div className='d-none d-md-block'>
                      <div
                        className='table-responsive'
                        style={{ maxHeight: '600px', overflowY: 'auto' }}
                      >
                        {isLoading ? (
                          <div className='table-loading'>
                            <div
                              className='spinner-border text-primary'
                              role='status'
                            >
                              <span className='visually-hidden'>
                                Loading...
                              </span>
                            </div>
                            <p className='mt-2'>Loading procurement data...</p>
                          </div>
                        ) : (
                          <DataTable
                            key={`sort-${getCurrentSortColumnId()}-${sortDirection}`}
                            columns={columns}
                            data={data.items || []}
                            pagination={false}
                            onSort={handleSort}
                            sortServer
                            defaultSortFieldId={getCurrentSortColumnId()}
                            defaultSortAsc={sortDirection === 'asc'}
                            highlightOnHover
                            responsive
                            striped
                            persistTableHead
                            progressPending={isLoading}
                            progressComponent={
                              <div className='text-center py-4'>
                                <div
                                  className='spinner-border text-primary'
                                  role='status'
                                >
                                  <span className='sr-only'>Loading...</span>
                                </div>
                                <p className='mt-2 text-muted'>
                                  Loading data...
                                </p>
                              </div>
                            }
                            dense
                            customStyles={{
                              header: {
                                style: {
                                  backgroundColor: '#f0f0f0',
                                  color: '#333',
                                  fontWeight: 'bold',
                                  minHeight: '40px',
                                },
                              },
                              headCells: {
                                style: {
                                  backgroundColor: '#f0f0f0',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  paddingLeft: '8px',
                                  paddingRight: '8px',
                                },
                              },
                              cells: {
                                style: {
                                  paddingLeft: '8px',
                                  paddingRight: '8px',
                                  wordBreak: 'break-word',
                                  paddingTop: '4px',
                                  paddingBottom: '4px',
                                },
                              },
                              rows: {
                                style: {
                                  minHeight: '45px',
                                },
                              },
                              table: {
                                style: {
                                  width: '100%',
                                },
                              },
                              tableWrapper: {
                                style: {
                                  display: 'table',
                                },
                              },
                            }}
                            noDataComponent={
                              <div className='table-empty'>
                                <i
                                  className='ri-inbox-line'
                                  style={{
                                    fontSize: '3rem',
                                    opacity: 0.5,
                                  }}
                                ></i>
                                <p>No procurement data found</p>
                                {(searchText ||
                                  statusFilter ||
                                  procTypeFilter) && (
                                  <small>Try adjusting your filters</small>
                                )}
                              </div>
                            }
                          />
                        )}
                      </div>

                      {/* Custom Pagination Controls - Outside Scrollable Area */}
                      <div className='d-flex justify-content-between align-items-center mt-3 px-3 py-2 border-top'>
                        <div className='d-flex align-items-center'>
                          <span className='text-muted me-2'>
                            Rows per page:
                          </span>
                          <select
                            className='form-select form-select-sm'
                            style={{ width: 'auto' }}
                            value={rowsPerPage}
                            onChange={e =>
                              handlePerRowsChange(parseInt(e.target.value))
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>

                        <div className='d-flex align-items-center'>
                          <span className='text-muted me-3'>
                            {totalRows > 0 ? (
                              <>
                                {(currentPage - 1) * rowsPerPage + 1}-
                                {Math.min(currentPage * rowsPerPage, totalRows)}{' '}
                                of {totalRows}
                              </>
                            ) : (
                              '0 of 0'
                            )}
                          </span>

                          <div className='btn-group' role='group'>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={currentPage === 1 || isLoading}
                              onClick={() => handlePageChange(1)}
                            >
                              <i className='ri-skip-back-line'></i>
                            </button>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={currentPage === 1 || isLoading}
                              onClick={() => handlePageChange(currentPage - 1)}
                            >
                              <i className='ri-arrow-left-s-line'></i>
                            </button>
                            <span className='btn btn-outline-secondary btn-sm disabled'>
                              {currentPage}
                            </span>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={
                                currentPage >=
                                  Math.ceil(totalRows / rowsPerPage) ||
                                isLoading
                              }
                              onClick={() => handlePageChange(currentPage + 1)}
                            >
                              <i className='ri-arrow-right-s-line'></i>
                            </button>
                            <button
                              type='button'
                              className='btn btn-outline-secondary btn-sm'
                              disabled={
                                currentPage >=
                                  Math.ceil(totalRows / rowsPerPage) ||
                                isLoading
                              }
                              onClick={() =>
                                handlePageChange(
                                  Math.ceil(totalRows / rowsPerPage)
                                )
                              }
                            >
                              <i className='ri-skip-forward-line'></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ToastContainer closeButton={false} limit={1} />
                  </CardBody>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size='lg'
        isOpen={modal}
        role='dialog'
        autoFocus={true}
        centered
        id='addAddressModal'
        toggle={togglemodal}
        data-bs-backdrop='static'
        className='modal-fullscreen-sm-down'
      >
        <ModalHeader
          className='bg-soft-info p-3'
          toggle={() => {
            setModal(!modal);
          }}
        ></ModalHeader>

        <ModalBody>
          <div className='d-flex mt-2'>
            <Col xxl={12}>
              <div>
                <Row>
                  <Row className='justify-content-center mb-1'>
                    <Col lg={12} className='text-center'>
                      <img
                        src={metaMask}
                        alt=''
                        height='65'
                        className='mb-3 pb-2'
                      />
                      <h5>Create New Planning & Procurementff </h5>
                      <p className='text-muted pb-1'>
                        Start a new procurement request by filling in the
                        details below.
                      </p>
                    </Col>
                  </Row>

                  <Col lg={12}>
                    <div className='mb-2 bor border-top  border-top-dashed '></div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <Label htmlFor='titleProcurement' className='form-label'>
                        Title Procurement
                      </Label>
                      <Input
                        type='text'
                        className='form-control '
                        id='titleProcurement'
                        name='titleProcurement'
                        placeholder='Enter Title Procurement'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            titleProcurement: '',
                          });
                        }}
                      />
                    </div>
                    {errors.titleProcurement && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.titleProcurement}</span>
                      </div>
                    )}{' '}
                  </Col>
                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <span
                        htmlFor='choices-publish-status-input'
                        className='form-label'
                      >
                        Proc Type{' '}
                      </span>

                      <Select
                        name='procurementType'
                        id='procurementType'
                        placeholder='-- Please Select --'
                        options={procurementtype}
                        onChange={e => {
                          handleprocurementTypeChange(e);
                          setErrors({
                            ...errors,
                            procurementType: '',
                          });
                        }}
                      />
                    </div>
                    {errors.procurementType && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.procurementType}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <div>
                      <Label
                        htmlFor='exampleFormControlTextarea5'
                        className='form-label'
                      >
                        Description{' '}
                      </Label>
                      <textarea
                        className='form-control'
                        id='description'
                        name='description'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            description: '',
                          });
                        }}
                        rows='5'
                      ></textarea>
                    </div>
                    {errors.description && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.description}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='hstack gap-2 justify-content-end d-print-none mt-4 flex-wrap'>
            <button
              color='primary'
              type='button'
              className='btn btn-primary flex-fill flex-sm-grow-0'
              onClick={closeModal}
            >
              <i className='ri-logout-box-line align-bottom me-1'></i>Close
            </button>
            <button
              type='submit'
              className='btn btn-primary btn-label right ms-auto nexttab flex-fill flex-sm-grow-0'
              onClick={handleSubmit}
            >
              <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2'></i>{' '}
              Next
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default ProcurementView;
